"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require("redbox-react");

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require("react");

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require("react-transform-catch-errors");

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Product: {
    displayName: "Product"
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: "/home/runner/work/redux-frontend/redux-frontend/src/components/StructuredData/Product.js",
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Product = _wrapComponent("Product")((_temp = _class = function (_Component) {
  (0, _inherits3.default)(Product, _Component);

  function Product() {
    (0, _classCallCheck3.default)(this, Product);
    return (0, _possibleConstructorReturn3.default)(this, (Product.__proto__ || (0, _getPrototypeOf2.default)(Product)).apply(this, arguments));
  }

  (0, _createClass3.default)(Product, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          name = _props.name,
          ratingValue = _props.ratingValue,
          reviewCount = _props.reviewCount,
          price = _props.price;

      return _react3.default.createElement(
        "div",
        { itemScope: true, itemType: "http://schema.org/Product" },
        _react3.default.createElement("div", { itemProp: "name", content: name }),
        (reviewCount || 0) > 0 && _react3.default.createElement(
          "div",
          { itemScope: true, itemProp: "aggregateRating", itemType: "http://schema.org/AggregateRating" },
          _react3.default.createElement("meta", { itemProp: "ratingValue", content: ratingValue || 0 }),
          _react3.default.createElement("meta", { itemProp: "reviewCount", content: reviewCount || 0 })
        ),
        price && _react3.default.createElement(
          "div",
          { itemScope: true, itemProp: "offers", itemType: "http://schema.org/Offer" },
          _react3.default.createElement("meta", { itemProp: "priceCurrency", content: "THB" }),
          _react3.default.createElement("meta", { itemProp: "price", content: price })
        )
      );
    }
  }]);
  return Product;
}(_react2.Component), _class.propTypes = {
  name: _react2.PropTypes.string,
  ratingValue: _react2.PropTypes.number,
  reviewCount: _react2.PropTypes.number,
  price: _react2.PropTypes.number
}, _temp));

exports.default = Product;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./src/components/StructuredData/Product.js
// module id = 474
// module chunks = 0 2